import type { MatterPhase } from "@/lib/types";
import {
  AlertTriangle,
  Check,
  Circle,
  Clock3,
  Lock,
  ShieldAlert,
} from "lucide-react";

export function MatterPhaseProgressRing({
  phase,
  ringColor,
}: {
  phase: MatterPhase;
  ringColor: string;
}) {
  const completeActions = phase.actions.filter((action) =>
    ["Complete", "Closed"].includes(action.effectiveStatus),
  ).length;
  const percent = phase.actions.length
    ? Math.round((completeActions / phase.actions.length) * 100)
    : 0;

  return (
    <span
      className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full"
      style={{
        background: `conic-gradient(${ringColor} ${percent}%, #e5e7eb ${percent}% 100%)`,
      }}
      aria-label={`${percent}% complete`}
    >
      <span className="bg-card flex h-8 w-8 items-center justify-center rounded-full">
        {phase.effectiveStatus === "Complete" ? (
          <Check className="h-4 w-4 text-emerald-600" />
        ) : phase.effectiveStatus === "Closed" ? (
          <Lock className="h-3.5 w-3.5 text-slate-600" />
        ) : phase.effectiveStatus === "Blocked" ? (
          <ShieldAlert className="h-4 w-4 text-red-600" />
        ) : phase.needsAttention ? (
          <AlertTriangle className="h-4 w-4 text-amber-600" />
        ) : phase.effectiveStatus === "Active" ? (
          <Clock3 className="h-4 w-4 text-amber-600" />
        ) : (
          <Circle className="text-muted-foreground h-3.5 w-3.5" />
        )}
      </span>
    </span>
  );
}
